import React, { useState } from "react";
import classes from "./styles.module.scss";
import { Carousel } from "react-bootstrap";
import Body from "@/ui/Body";
import Title from "@/ui/Title";
import Button from "../../components/Button";
import { content_tiles_helper } from "@/helpers/content_tiles_helper";

export const CTASection = ({ category , items, style = "carousel_style" || "" }) => {
  items = content_tiles_helper.fetch({ category: category });
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  return (
    <div className={classes.section}>
      <Carousel
        className={classes.carousel}
        controls={false}
        interval={3000}
        indicators={false}
        activeIndex={index}
        onSelect={handleSelect}
      >
        {items.map(({ title, description, image, video, main_image, link, variant, button }, k) => (
          <Carousel.Item key={k}>
            <div className={classes.tile}>
              {style == "plain" ? <></> : <div className={classes.background}></div>}
              <div className={classes.image}>
                {style == "plain" || !image ? <></> : <img src={image} alt={title} />}
              </div>
              <div className={classes.video}>
                {main_image ? <img src={main_image} alt={title} /> : <img src={video} alt={title} />}
                <div className={classes.nav_cont}>
                  {items.map((_, itemIndex) => {
                    return (
                      <div
                        className={`${classes.nav_button} ${index == itemIndex ? classes.active : ""}`}
                        onClick={() => handleSelect(itemIndex)}
                        key={itemIndex}
                      ></div>
                    );
                  })}
                </div>
              </div>
              <div className={classes.content}>
                <div>
                  <Title
                    title={title}
                    containerClass={"highlight-titles-" + k}
                    className={`${variant} highlight font-weight-light size-h2`}
                    tag="h2"
                    highlight={true}
                    variant={variant}
                    hideBr={true}
                  />
                  <Body body={description} className="pb-3" />
                </div>
                {button && (
                  <Button display={button} animation={true} link={link} className={`font-regular btn-primary`}></Button>
                )}
              </div>
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
};

export default CTASection;
